"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _FilterLabel = _interopRequireDefault(require("../FilterLabel"));
var _RadioButton = _interopRequireDefault(require("../RadioButton"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var RadioFilter = function RadioFilter(_ref) {
  var name = _ref.name,
    items = _ref.items,
    onChange = _ref.onChange,
    className = _ref.className,
    LabelComponent = _ref.LabelComponent,
    isMobile = _ref.isMobile;
  return /*#__PURE__*/_react["default"].createElement(StyledRadioFilter, {
    className: className,
    isMobile: isMobile
  }, items.map(function (item) {
    var id = item.id,
      path = item.path,
      selected = item.selected,
      disabled = item.disabled,
      hotel_count = item.hotel_count,
      suitable_flights = item.suitable_flights,
      price = item.min_price,
      currencyCode = item.currencyCode;
    var count = hotel_count || suitable_flights;
    return /*#__PURE__*/_react["default"].createElement(StyledRadio, {
      name: name,
      key: "".concat(path || 'filter', "-").concat(id),
      value: id,
      checked: selected,
      disabled: disabled,
      onClick: function onClick() {
        return onChange(_objectSpread(_objectSpread({}, item), {}, {
          selected: !selected
        }));
      }
    }, /*#__PURE__*/_react["default"].createElement(LabelComponent, (0, _extends2["default"])({}, item, {
      isMobile: isMobile,
      count: count,
      price: price,
      currencyCode: currencyCode
    })));
  }));
};
var StyledRadio = (0, _styledComponents["default"])(_RadioButton["default"]).withConfig({
  displayName: "RadioFilter__StyledRadio",
  componentId: "sc-1gwqg8i-0"
})(["display:flex;align-items:start;margin-bottom:7px;"]);
var StyledRadioFilter = _styledComponents["default"].div.withConfig({
  displayName: "RadioFilter__StyledRadioFilter",
  componentId: "sc-1gwqg8i-1"
})(["", "{", "}"], StyledRadio, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && (0, _styledComponents.css)(["box-sizing:border-box;flex-direction:row-reverse;align-items:center;margin:0;padding:10px;input{margin-right:0;margin-left:8px;width:24px;height:24px;flex-shrink:0;&::before{width:100%;height:100%;}&::after{width:10px;height:10px;}}"]);
});
RadioFilter.propTypes = {
  name: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  onChange: _propTypes["default"].func.isRequired,
  LabelComponent: _propTypes["default"].func,
  isMobile: _propTypes["default"].bool
};
RadioFilter.defaultProps = {
  className: '',
  LabelComponent: _FilterLabel["default"],
  isMobile: false
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(RadioFilter);